import React from 'react';
import { Home } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid, Steps } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function EquityShieldPage() {
  const module = getModule('equity-shield')!;
  return (
    <ModulePageLayout module={module} Icon={Home}>
      <Section title="Buy and Sell Real Estate, Skip the Commission">
        <p className="text-gray-700 leading-relaxed">
          Equity Shield connects buyers and sellers directly, bypassing the 5–6% commission a traditional agent
          would charge. We calculate exactly how much you saved versus that traditional fee — full
          transparency is the core of the value proposition.
        </p>
      </Section>

      <Section title="Deal Flow">
        <Steps
          items={[
            'A seller lists a property with full legal documentation: type, address, market value, registration status, and any encumbrances.',
            'Buyers express interest with their financing status, loan type, and decision-maker details.',
            'Negotiation happens through built-in real-time chat, with formal offers tracked through to acceptance.',
            'The deal moves through Agreement of Purchase and Sale → Legal Review → Sold.',
          ]}
        />
      </Section>

      <Section title="Where the Savings Go">
        <FeatureGrid
          items={[
            { title: 'Savings Calculation', body: 'See exactly how much you saved versus a traditional agent commission, transparently broken down.' },
            { title: 'Investment Redirection', body: 'Automatically invest your savings into FAME assets, trust accounts, or your own savings goals.' },
            { title: 'Fractional Ownership', body: 'Properties can be fractionalized for co-investment, connecting directly into the FAME ecosystem.' },
            { title: 'Real Estate Capital Pools', body: 'Sector-specific capital pools for collective property investment, when you want to invest with others.' },
          ]}
        />
      </Section>
    </ModulePageLayout>
  );
}
